// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-item-module--item--88H9l","textPlaceholder":"menu-item-module--textPlaceholder--2YToo","active":"menu-item-module--active--1E8No"};